export default {
  section: {
    width: '100%',
    padding: ['0 16px', '0 16px', '0 24px', '0 24px', '0 40px'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: ['space-around', 'space-between'],
    alignItems: 'center',
    flexWrap: 'no-wrap'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '1920px',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 16px 40px 16px',
    mb: '60px'
  },
  titleContainer: {
    width: '100%',
    maxWidth: '1530px'
  },
  column: (isMobile: boolean) => ({
    position: 'relative',
    ':not(.row__column--paddingless)': {
      padding: isMobile ? `8px 0` : ''
    },
    '::before': theme => ({
      content: '""',
      width: '100%',
      position: 'absolute',
      height: 1,
      opacity: 1,
      background: theme.rawColors.lightGrey300
    })
  }),
  productsRow: {
    width: '100%',
    pt: '40px',
    gridGap: '4px',
    // override bootstrap link style from simple configurator
    '.vox-row__column': {
      'a:hover': {
        textDecoration: 'none !important'
      }
    }
  },
  loader: {
    position: 'relative',
    width: '100%',
    height: '200px',
    padding: ['0 16px', '0 16px', '0 24px', '0 24px', '0 40px']
  },
  progressLineSize: {
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto'
  },
  buttonCenter: {
    display: 'flex',
    justifyContent: 'center',
    mb: '28px'
  }
};